import { useContext } from "react"
import * as React from "react"
import { Context } from "../../../store/store"
import ElemCheckboxMafo from "../../elements/CheckboxMafo"

interface MafoQuestionProps {
	formElementChanged: Function
	validation: Object
}
const MafoQuestionFive: React.FC<MafoQuestionProps> = ({ formElementChanged, validation }) => {
	const { globalState } = useContext(Context)
	return (
		<>
			<h3 className="font-Alpro mb-2 text-left text-center  text-[24px] text-blue lg:text-center lg:text-[32px]">Hattest Du Deinen Alpro Einkauf geplant?</h3>
			<div className="mx-auto grid grid-cols-1 flex-row text-left lg:max-w-[75%]">
				<ElemCheckboxMafo
					label={<>Ja, ich wollte
						sowieso Alpro
						kaufen  </>}
					props={{
						type: "radio",
						name: "question5",
						value: "a",
						onClick: e => formElementChanged(e, "question5"),
					}}
					hasError={validation["invalid_question5"] ? true : false}
					className=" pb-2 text-green"
					errMsg={validation["invalid_question5_errMsg"] || ""}
				/>
				<ElemCheckboxMafo
					label={<>Nein, ich habe
						mich spontan im
						Markt entschieden  </>}
					props={{
						type: "radio",
						name: "question5",
						value: "b",
						onClick: e => formElementChanged(e, "question5"),
					}}
					hasError={validation["invalid_question5"] ? true : false}
					className=" pb-2 text-green"
					errMsg={validation["invalid_question5_errMsg"] || ""}
				/>
				<ElemCheckboxMafo
					label={<> Ich wollte
						eigentlich andere
						pflanzliche
						Produkte/Marken
						kaufen  </>}
					props={{
						type: "radio",
						name: "question5",
						value: "c",
						onClick: e => formElementChanged(e, "question5"),
					}}
					hasError={validation["invalid_question5"] ? true : false}
					className=" pb-2 text-green"
					errMsg={validation["invalid_question5_errMsg"] || ""}
				/>
				<ElemCheckboxMafo
					label={<>Neben Alpro,
						habe ich auch
						andere pflanzliche
						Produkte/Marken
						gekauft  </>}
					props={{
						type: "radio",
						name: "question5",
						value: "d",
						onClick: e => formElementChanged(e, "question5"),
					}}
					hasError={validation["invalid_question5"] ? true : false}
					className=" pb-2 text-green"
					errMsg={validation["invalid_question5_errMsg"] || ""}
				/>
			</div>
		</>
	)
}

export default MafoQuestionFive
